import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { constitutionResponse } from '../../../api/ConstitutionVote';
import { getTokenStatus } from '../../../shared/redux/selectors';
import Loading from '../../../shared/components/Loading';
import VoteResultsContainer from './VoteResultsContainer';

function VoteContainer({ tokenStatus }) {
  const history = useHistory();
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  if (!tokenStatus) {
    return <Loading />;
  }

  if (tokenStatus === constitutionResponse.THANKYOU) {
    scrollToTop();
    history.push('/thankyou');
  }

  return <VoteResultsContainer />;
}

VoteContainer.defaultProps = {
  tokenStatus: null,
};

VoteContainer.propTypes = {
  tokenStatus: PropTypes.string,
};

const mapStateToProps = (state) => ({
  tokenStatus: getTokenStatus(state),
});

export default connect(
  mapStateToProps,
)(VoteContainer);
